/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import * as PropTypes from 'prop-types';
import {ProductDetailModelType} from "./product-details.model";

export const RecipeListIngredient = PropTypes.shape({
    "addRemark": PropTypes.string,
    "ingredientLabel": PropTypes.string,
    "ingredientPercentage": PropTypes.string,
    "ingredientProductLink": PropTypes.string,
    "ingredientType": PropTypes.string,
    "ingredientUnits": PropTypes.string,
    "ingredientUnitsTrans": PropTypes.string,
    "label": PropTypes.bool,
    "link": PropTypes.bool,
    "productDetails": PropTypes.shape(ProductDetailModelType),
});

export const RecipeListGroup = PropTypes.shape({
    "groupTotalLabel": PropTypes.string,
    "groupTotalUnits": PropTypes.string,
    "hideTotalUnits": PropTypes.bool,
    "ingredients": PropTypes.arrayOf(RecipeListIngredient),
});

export const RecipeListModelType = {
    "empty": PropTypes.bool,
    "groups": PropTypes.arrayOf(RecipeListGroup),
    "ingredientRemarkPercentage": PropTypes.string,
    "ingredientRemarkUnits": PropTypes.string,
    "ingredientsRemark": PropTypes.string,
    "percentageHeader": PropTypes.string,
    "showPercentage": PropTypes.bool,
    "unitsHeader": PropTypes.string,
};
